module.exports = __webpack_public_path__ + "img/cloud-xmark.51ab56b0.svg";